import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

localStorage.removeItem("rb_token");

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && !e.config?.url?.includes("/auth/")) {
      window.location.href = "/login";
    }
    return Promise.reject(e);
  }
);

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null && e?.response?.status === 404) return "Serveur momentanément indisponible. Réessayez dans quelques secondes.";
  if (detail == null) return e?.message || "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail.msg || String(detail);
}

const fmt = new Intl.NumberFormat("fr-CA", { style: "currency", currency: "CAD" });
export const money = (v) => fmt.format(Number(v) || 0);

export const cleanParams = (f) =>
  Object.fromEntries(Object.entries(f).filter(([, v]) => v !== undefined && v !== null && v !== "" && v !== "all"));

export async function telechargerExcel(titre, { colonnes, lignes }) {
  await telechargerPost("/exports/tableau", { titre, colonnes, lignes }, {}, `${titre}.xlsx`);
}

export async function telechargerPdf(titre, { colonnes, lignes }) {
  await telechargerPost("/exports/tableau-pdf", { titre, colonnes, lignes }, {}, `${titre}.pdf`);
}

export async function telechargerPost(path, body, params, fallbackName) {
  const r = await api.post(path, body, { params, responseType: "blob" });
  enregistrerBlob(r, fallbackName);
}

export async function download(path, params, fallbackName, horodate = true) {
  const r = await api.get(path, { params, responseType: "blob" });
  enregistrerBlob(r, fallbackName, horodate);
}

export const horodater = (name) => {
  const d = new Date();
  const p = (x) => String(x).padStart(2, "0");
  const tag = `_généré-le_${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}_${p(d.getHours())}h${p(d.getMinutes())}`;
  const i = name.lastIndexOf(".");
  return i > 0 ? `${name.slice(0, i)}${tag}${name.slice(i)}` : `${name}${tag}`;
};

function enregistrerBlob(r, fallbackName, horodate = true) {
  const cd = r.headers["content-disposition"] || "";
  const m = /filename\*=UTF-8''([^;]+)/.exec(cd) || /filename="([^"]+)"/.exec(cd);
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  const nom = m ? decodeURIComponent(m[1]) : fallbackName;
  a.download = horodate ? horodater(nom) : nom;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export const MOIS_FR = ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."];
export const moisLabel = (m) => {
  if (!m) return "";
  const [y, mm] = m.split("-");
  return `${MOIS_FR[Number(mm) - 1]} ${y}`;
};
